module.exports = {
    ra: {
        action: {
            add_filter: 'Ychwanegu hidlydd',
            add: 'Ychwanegu',
            back: 'Ôl',
            bulk_actions:
                '%{smart_count} eitem a ddewiswyd |||| %{smart_count} eitemau a ddewiswyd',
            cancel: 'Canslo',
            clear_input_value: 'Gwerth clir',
            clone: 'Clôn',
            confirm: 'Gadarnhau',
            create: 'Greu',
            delete: 'Dileu',
            edit: 'Golygu',
            export: 'Allforio',
            list: 'Rhestr',
            refresh: 'Adnewyddu',
            remove_filter: 'Tynnu ir hidlydd hwn',
            remove: 'Dileu',
            save: 'Arbed',
            search: 'Chwilio',
            show: 'Dangos',
            sort: 'Math',
            undo: 'Dad - wneud',
            expand: 'Ehangu',
            close: 'Agos',
        },
        boolean: {
            true: 'Yess',
            false: 'Na',
        },
        page: {
            create: 'Greu %{name}',
            dashboard: 'Dangosfwrdd',
            edit: '%{name} #%{id}',
            error: 'Gwall',
            list: '%{name}',
            loading: 'Llwytho',
            not_found: 'Heb ei ganfod',
            show: '%{name} #%{id}',
        },
        input: {
            file: {
                upload_several:
                    "Gollyngwch rai ffeiliau i ' w llwytho i fyny, neu cliciwch i ddewis un.",
                upload_single:
                    "Gollwng ffeil i ' w lanlwytho, neu glicio i ' w dewis.",
            },
            image: {
                upload_several:
                    "Gollyngwch rai lluniau i ' w llwytho i fyny, neu cliciwch i ddewis un.",
                upload_single:
                    "Gollwng Llun i ' w lanlwytho, neu glicio i ' w ddewis.",
            },
            references: {
                all_missing: 'Methu canfod data cyfeiriedig.',
                many_missing:
                    "Mae ' n ymddangos nad yw o leiaf un o ' r cyfeiriadau cysylltiedig ar gael mwyach.",
                single_missing:
                    "Nid yw ' n ymddangos bod geirda cysylltiedig ar gael mwyach.",
            },
        },
        message: {
            about: 'Am',
            are_you_sure: "Wyt ti'n siŵr?",
            bulk_delete_content:
                "Ydych chi ' n siŵr eich bod am ddileu ' r %{name}?|||| Êtes-vous sYdych chi ' n siŵr eich bod am ddileu ' r  %{smart_count} eitem hyn?",
            bulk_delete_title:
                'Dileu %{name} |||| Dileu %{smart_count} %{name}',
            delete_content:
                "Ydych chi ' n siŵr eich bod am ddileu ' r eitem?",
            delete_title: 'Dileu %{name} #%{id}',
            details: 'Manylion',
            error:
                "Mae gwall cleient wedi digwydd a doedd dim modd gorffen eich cais.",
            invalid_form: "Nid yw ' r ffurflen yn ddilys. Gwiriwch am wallau",
            loading:
                "Mae ' r dudalen yn llwytho, dim ond eiliad os gwelwch yn dda",
            no: 'Na',
            not_found:
                "Naill ai fe deipioch URL anghywir, neu fe wnaethoch chi ddilyn cyswllt gwael.",
            yes: 'Yess',
        },
        navigation: {
            no_results: 'Heb ganfod canlyniadau',
            no_more_results:
                'Mae Rhif Tudalen %{page} yn waharddedig. Rhowch gynnig ar y dudalen flaenorol.',
            page_out_of_boundaries: 'Mae Rhif Tudalen %{page} yn waharddedig.',
            page_out_from_end: 'Methu mynd ar ôl y dudalen olaf',
            page_out_from_begin: 'Does dim modd mynd cyn Tudalen 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} o %{total}',
            page_rows_per_page: 'Rhesi fesul tudalen :',
            next: 'Nesaf',
            prev: 'Blaenorol',
        },
        auth: {
            user_menu: 'Proffil',
            username: 'Enw defnyddiwr',
            password: 'Cyfrinair',
            sign_in: 'Mewngofnodi',
            sign_in_error: "Wedi methu dilysu, rhowch gynnig arall arni",
            logout: 'Allgofnodi',
        },
        notification: {
            updated:
                "Elfen wedi ' i diweddaru |||| %{smart_count} elfennau wedi ' u diweddaru",
            created: 'Elfen a grëwyd',
            deleted: 'Wedi dileu elfen |||| %{smart_count} elfennau a ddilëwyd',
            bad_item: 'Elfen wael',
            item_doesnt_exist: "Nid yw ' r elfen yn bodoli",
            http_error: "Gwall wrth gyfathrebu â ' r gweinydd",
            data_provider_error:
                'Gwall dataProvider. Gwiriwch y consol am fanylion.',
            canceled: 'Diddymwyd y weithred',
            logged_out: 'Gorffen eich sesiwn.  A wnewch chi ailgysylltu',
        },
        validation: {
            required: 'Ofynnol',
            minLength: 'lleiafswm o %{min} chymeriad',
            maxLength: 'uchafswm o %{max} chymeriad',
            minValue: 'lleiafswm o %{min}',
            maxValue: 'uchafswm o %{max}',
            number: 'Rhaid i nifer',
            email: 'Rhaid bod yn e-bost',
            oneOf: 'Rhaid iddo fod yn un o: %{options}',
            regex: 'Rhaid iddo gydweddu â fformat penodol (regexp): %{pattern}',
        },    
    },
};